import type { BadgeColors } from "@/components/base/badges/badge-types";

type NetworkBadgeColor =
	| "network-ethereum"
	| "network-arbitrum"
	| "network-base"
	| "network-optimism"
	| "network-unichain"
	| "network-robinhood";

const NETWORK_BADGE_COLOR_MAP: Record<string, NetworkBadgeColor> = {
	ethereum: "network-ethereum",
	arbitrum: "network-arbitrum",
	base: "network-base",
	optimism: "network-optimism",
	unichain: "network-unichain",
	robinhood: "network-robinhood",
};

export function getNetworkBadgeColor(network: string): BadgeColors {
	return NETWORK_BADGE_COLOR_MAP[network.trim().toLowerCase()] ?? "gray";
}
